package org.solyton.solawi.bid.module.navbar.`data`.navbar

import kotlin.Int
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.compose.modal.Modals
import org.evoleq.device.`data`.Device
import org.evoleq.optics.lens.Lens
import org.evoleq.optics.storage.ActionDispatcher
import org.solyton.solawi.bid.module.i18n.`data`.I18N
import org.solyton.solawi.bid.module.navbar.`data`.environment.Environment
import org.solyton.solawi.bid.module.navbar.`data`.user.User

/**
 * Autogenerated ReadOnly Lens.
 * Read [NavBar.actions]
 */
@ReadOnly
public val actions: Lens<NavBar, ActionDispatcher<NavBar>> by lazy {
      Lens(
        get = { whole -> whole.actions },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [NavBar.modals]
 */
@ReadWrite
public val modals: Lens<NavBar, Modals<Int>> by lazy {
      Lens(
        get = { whole -> whole.modals },
        set = { part -> { whole -> whole.copy(modals = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [NavBar.modals]
 */
@ReadWrite
public fun NavBar.modals(`set`: Modals<Int>.() -> Modals<Int>): NavBar = copy(modals = set(modals))

/**
 * Autogenerated ReadOnly Lens.
 * Read [NavBar.deviceData]
 */
@ReadOnly
public val deviceData: Lens<NavBar, Device> by lazy {
      Lens(
        get = { whole -> whole.deviceData },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [NavBar.i18n]
 */
@ReadWrite
public val i18n: Lens<NavBar, I18N> by lazy {
      Lens(
        get = { whole -> whole.i18n },
        set = { part -> { whole -> whole.copy(i18n = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [NavBar.i18n]
 */
@ReadWrite
public fun NavBar.i18n(`set`: I18N.() -> I18N): NavBar = copy(i18n = set(i18n))

/**
 * Autogenerated ReadOnly Lens.
 * Read [NavBar.environment]
 */
@ReadOnly
public val environment: Lens<NavBar, Environment> by lazy {
      Lens(
        get = { whole -> whole.environment },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [NavBar.user]
 */
@ReadWrite
public val user: Lens<NavBar, User> by lazy {
      Lens(
        get = { whole -> whole.user },
        set = { part -> { whole -> whole.copy(user = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [NavBar.user]
 */
@ReadWrite
public fun NavBar.user(`set`: User.() -> User): NavBar = copy(user = set(user))
